export const formatRecurrenceText = (
  recurrenceType,
  recurrenceInterval,
  recurrenceDaysOfWeek
) => {
  const dayNames = {
    1: "Sunday",
    2: "Monday",
    3: "Tuesday",
    4: "Wednesday",
    5: "Thursday",
    6: "Friday",
    7: "Saturday",
  };

  if (recurrenceType === "CUSTOM") {
    if (
      !recurrenceDaysOfWeek ||
      !Array.isArray(recurrenceDaysOfWeek) ||
      recurrenceDaysOfWeek.length === 0
    ) {
      return "Custom recurrence";
    }

    const sortedDays = [...recurrenceDaysOfWeek].sort((a, b) => a - b);

    const dayNamesList = sortedDays.map((day) => dayNames[day]).filter(Boolean);

    if (dayNamesList.length === 0) {
      return "Custom recurrence";
    }

    if (dayNamesList.length === 1) {
      return `Every ${dayNamesList[0]}`;
    } else if (dayNamesList.length === 2) {
      return `Every ${dayNamesList[0]} and ${dayNamesList[1]}`;
    } else {
      const lastDay = dayNamesList.pop();
      return `Every ${dayNamesList.join(", ")} and ${lastDay}`;
    }
  }

  const interval = recurrenceInterval || 1;

  switch (recurrenceType) {
    case "DAY":
      if (interval === 1) {
        return "Every day";
      }
      return `Every ${interval} days`;

    case "WEEK":
      if (interval === 1) {
        return "Every week";
      }
      return `Every ${interval} weeks`;

    case "MONTH":
      if (interval === 1) {
        return "Every month";
      }
      return `Every ${interval} months`;

    default:
      return "Unknown recurrence";
  }
};
